// Fecha "de hoy" en Costa Rica (UTC-6 todo el año, sin horario de verano).
// Mismo criterio que la app usó siempre (Date.now() - 6 h), en un solo lugar
// y probado: a las 18:00 de Costa Rica ya es medianoche UTC y sigue siendo hoy.
const SEIS_HORAS = 6 * 3600 * 1000;

export const hoyCR = (ahora = Date.now()) => new Date(ahora - SEIS_HORAS).toISOString().slice(0, 10);

// 'YYYY-MM-DD' -> 'martes 13 de octubre'. Se interpreta a mediodía UTC para
// que ninguna zona horaria la corra de día.
export const fechaLarga = (fecha) => {
  if (!fecha || !/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return '';
  const d = new Date(`${fecha}T12:00:00Z`);
  const dia = d.toLocaleDateString('es-CR', { weekday: 'long', timeZone: 'UTC' });
  const mes = d.toLocaleDateString('es-CR', { month: 'long', timeZone: 'UTC' });
  return `${dia} ${d.getUTCDate()} de ${mes}`;
};
